import React, { Component } from 'react';
import KeyboardBackspace from '@material-ui/icons/ArrowBack';
import PartnerContact from '../../../../Components/PartnerContact';
import Button from '../../../../Components/Button';
import { I18n } from 'react-redux-i18n';
import './style.scss';
import { IconButton, Button as ButtonMui } from '@material-ui/core';
import { Info } from '@material-ui/icons';
import { connect } from 'react-redux';

class PartnerContainer extends Component {
	render() {
		if (!this.props.id) {
			window.location = '/';
			return '';
		}
		return (
			<div className="content-container">
				<div className="subHeader-container">
					<div className="left-container">
						<Button
							onClick={() => {
								window.location.href = '/partners';
							}}
							color="primary"
							icon={KeyboardBackspace}>
							{I18n.t('general.back')}
						</Button>
					</div>
					<div className="center-container">
						<h1>{this.props.name}</h1>
						<div className="btn-info-partner">
							<button
								onClick={() =>
									this.props.dispatchDisplayPartnerInfo(this.props.prefix)
								}>
								INFOS <Info />
							</button>
						</div>
					</div>
					<div className="right-container"></div>
				</div>
				<div className="partners-container">
					<div className="partners-subcontainer">
						<PartnerContact prefix={this.props.prefix} />
						{this.props.children}
					</div>
				</div>
			</div>
		);
	}
}

const mSTP = state => ({});

const mapDispatchToProps = dispatch => {
	return {
		dispatchDisplayPartnerInfo: prefix =>
			dispatch({ type: 'PARTNER_DISPLAY_INFO_PARTNER', prefix }),
	};
};
export default connect(mSTP, mapDispatchToProps)(PartnerContainer);
